export const RevertNameList = [
    "shalza",
    "rishi",
    "shashank",
    "mrinal",
    "ankur",
    "devang",
    "gulshan",
    "vidit",
    "deeksha",
    "riya",
    "himalaya",
    "prerna",
    "aniket",
    "mokshee",
    "hardik",
    "inzamam",
    "chetan",
    "priyanka",
    "Kuldeep",
    "sudhanshu",
    "nishant",
    "deepanshu",
    "Shubham"
];
export const enhancementStatusChangeNameList = [
    "riya",
    "rishi",
    "himalaya",
    "devang",
    "shalza",
    "aniket",
    "Kuldeep",
    "Shubham"
];
